<template>
	<el-form ref="form" :model="form" label-width="220px" class="form" :rules="rules"  :validate-on-rule-change="false">
		<div class="cardBox">
			<div class="card">
				<el-form-item label="注册人身份证人像面" prop="cphoto">
					<el-upload class="avatar-uploader" :action="picUrl"
						v-loading.fullscreen.lock="loadingA"
						element-loading-text="拼命加载中……"
						:on-progress="changeA"
						element-loading-background="rgba(250, 250, 250, 0.5)"
						:before-upload="beforeAvatarUploadA"
						:show-file-list="false" :data="fileInfo" :on-success="handleCardA" accept="image/jpeg,image/png">
						
						<img v-if="imageUrlA" :src="imageUrlA" :onerror="imgSrc" class="avatar">
						
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<div class="tishinews">
						小提示：上传图片只能是JPG/PNG格式且上传图片大小不能超过 5MB！
					</div>
				</el-form-item>
				<el-form-item label="注册人身份证国徽面" prop="cphoto_back">
					
					<el-upload class="avatar-uploader" :action="picUrl"
					
						v-loading.fullscreen.lock="loadingB"
						
						  element-loading-text="拼命加载中……"
						  
						 :on-progress="changeB"
						 
						 :before-upload="beforeAvatarUploadB"
						 
						 element-loading-background="rgba(250, 250, 250, 0.5)"
						 
						:show-file-list="false" :data="fileInfo" :on-success="handleCardB" accept="image/jpeg,image/png">
						
						<img v-if="imageUrlB" :src="imageUrlB" :onerror="imgSrc" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						
					</el-upload>
					<div class="tishinews">
						小提示：上传图片只能是JPG/PNG格式且上传图片大小不能超过 5MB！
					</div>
				</el-form-item>
			</div>
			<!-- <div class="red">注：请上传法人身份证照片</div> -->
		</div>
		<el-form-item label="注册人" prop="cperson" class="name">
			<el-input v-model="form.cperson" />
		</el-form-item>
		<el-form-item label="注册人身份证号" prop="cpcode">
			<el-input v-model="form.cpcode" />
		</el-form-item>
		<el-form-item label="联系电话" prop="cphone">
			<el-input v-model="form.cphone" />
		</el-form-item>
		<el-form-item>
			<div style="display: flex;">
				<el-checkbox v-model="checked1" @change="handleCheckboxChange"><span class="text_">已阅读并同意以下协议</span><span style="color:#409eff;">消毒设备网平台商家入驻协议</span> 、</el-checkbox><a href="https://www.chinaxdsb.com/fwtk.html">服务条款</a>、<a href="https://www.chinaxdsb.com/priv.html">隐私权政策</a>、<a href="https://www.chinaxdsb.com/flsm.html">法律声明</a>
			</div>
		</el-form-item>
		<el-form-item>
			<el-button type="primary" @click="onSubmit">下一步</el-button>
		</el-form-item>
		<el-dialog
		      title="商家入驻协议"
		      :visible.sync="dialogVisible"
		      width="70%"
		      :close-on-click-modal="false"
		      :close-on-press-escape="false"
		      :show-close="false">
		      <div class="dialog-content" ref="dialogContent" @scroll="handleScroll">
				<h1 class="page-title">商家入驻协议</h1>
				<div class="protocol-info">
				  <p>甲方：河北冠宇环保设备股份有限公司</p>
				  <p>乙方：您或您代表的企业</p>
				</div>
				<div class="agreement-content">
				  <div class="preamble">
				    <p>基于，产业链发展是企业发展之路，环保产业链发展是大环保发展之路。互联网+环保产业链+大数据+产业链盟是促使目前当下行业改革，行业大洗牌、行业发展的高效途径。消毒设备网是由河北冠宇环保设备股份有限公司独立开发、运营的电子商务平台。为达到合作共赢的目的，经甲乙双方协商一致，签订如下协议：</p>
				  </div>
				  <el-collapse v-model="activeNames" accordion>
				    <!-- 第一条 会员资格 -->
				    <el-collapse-item title="第一条 会员资格" name="1">
				      <div class="clause-content">
				        <p><b>乙方承诺完全同意甲方在网站公布的入会规则并在消毒设备网网站完成注册程序后，即成为本网站会员。</b></p>
				      </div>
				    </el-collapse-item>
				
				    <!-- 第二条 会员费用 -->
				    <el-collapse-item title="第二条 会员费用" name="2">
				      <div class="clause-content">
				        <p>1．会员无须交纳会员费；</p>
				        <p>2．如需会员缴纳会员费，需双方签署书面协议认可。</p>
				      </div>
				    </el-collapse-item>
				
				    <!-- 第三条 甲方权利义务 -->
				    <el-collapse-item title="第三条 甲方权利义务" name="3">
				      <div class="clause-content">
				        <h4>一、甲方权利</h4>
				        <p>1．有权审核、接受或拒绝乙方的入会申请，有权撤销或停止会员的全部或部分服务内容；</p>
				        <p>2．有权修订会员的权利和义务，有权修改或调整本网站的服务内容；</p>
				        <p>3．有权将修订的会员的权利和义务以E-mail形式通知会员，会员收到通知后仍继续使用本网站服务者即表示会员同意并遵守新修订内容。</p>
				        <p>4．本网提供的服务仅供会员独立使用，未经本网授权，会员不得将会员号授予或转移给第三方。会员如果有违此例，本网有权向客户追索商业损失并保留追究法律责任的权利。</p>
				        
				        <h4>二、甲方的义务</h4>
				        <p>1．认真做好本网站所涉及的网络及通信系统的技术维护工作，保证本网站的畅通和高效；</p>
				        <p>2．除不可抗拒的因素导致本网站临时停止或短时间停止服务以外，如需停止本网站的全部或部分服务时，提前在本网站上发布通知通告会员。</p>
				        <p>3．如网站因系统维护或升级等原因需暂停服务，将事先通过主页、电子邮件等方式公告会员；</p>
				        <p>4．因不可抗力而使本网站服务暂停，所导致会员任何实际或潜在的损失，甲方不做任何补偿；</p>
				        <p>5．甲方不承担会员因遗失密码而受到的一切损失。</p>
				        <p>6．本网仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如电脑、调制解调器及其他与接入互联网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费）均应由用户自行负担。</p>
				      </div>
				    </el-collapse-item>
				
				    <!-- 第四条 乙方权利义务 -->
				    <el-collapse-item title="第四条 乙方权利义务" name="4">
				      <div class="clause-content">
				        <h4>一、乙方权利</h4>
				        <p>1、互联网+环保产业链平台应用</p>
				        <p class="indent">A、免费入驻平台+免费使用平台网站+免费产品品牌塑造（品牌塑造限于高级、至尊会员）</p>
				        <p class="indent">B、支持促成企业和平台一起形成互联网+环保产业链的企业赢利模式和平台环保产业链经济的赢利模式</p>
				        
				        <p>2、平台产业链大联合</p>
				        <p class="indent">A、打通产业链上下游 形成一站式方案营销，打造产业链系统化市场营销体系</p>
				        <p class="indent">B、利用平台产业链模式解决企业的产、供、采、销的信息、交易、服务一切问题</p>
				        <p class="indent">C、结合利用平台形成企业的生产、供应、采购、销售产业链模式，使企业降低成本、提高效率、加大利润形成更大更强的企业竞争力行业竞争力。</p>
				        <p class="indent">D、形成企业和平台之间求职应聘、人才引进的高效机制，形成企业和平台之间内部人才培训机制和内部创业机制</p>
				        <p class="indent">E、加入平台十三大产业链的联盟组织"链盟会"形成平台和企业之间同创、共建、共赢的协会联盟组织</p>
				        
				        <p>3、取得平台专家团队支持和融入专家团队</p>
				        <p class="indent">A、取得水、气、土壤环保三大板块、十三个产业链各种专家的支持（限于平台高级、至尊会员）</p>
				        <p class="indent">B、企业成为水、气、土壤环保三大板块、十三个产业链各种专家支持企业平台发展（限于平台高级、至尊会员）</p>
				        
				        <p>4、政府职能 和平台一起 打造企业+平台的市场营销+社会营销体系的盈利模式</p>
				        
				        <p>5、信息大数据</p>
				        <p class="indent">A、企业会员+终端用户=B2B+B2C的平台架构体系形成平台和企业的信息大数据支撑</p>
				        <p class="indent">B、协会组织+大专院校+设计院研究院+第三方服务机构+政府职能部门的平台架构体系形成平台和企业的为信息数据保障</p>
				        
				        <p>6、利用平台交易、挣积分、晋升成为平台代理商、渠道商、生产商、合作伙伴、股东会员</p>
				        
				        <h4>二、乙方义务</h4>
				        <p>1、发布真实有效的求购、供应信息，并按所提供的求购、供应信息进行平台求购和供应</p>
				        <p>2、发布真实有效的产品行业应用、工程方案、技术应用等平台支持所需资料</p>
				        <p>3、联合上下游客户，推荐平台会员、专家、服务机构</p>
				        <p>4、利用平台交易、保证产品质量、遵守并执行和平台的各项合同协议、遵守并执行和客户的各项合同协议</p>
				        <p>5、卖家出售的商品被新闻媒体曝光、国家质监部门等行政管理部门通报，或经消毒设备网平台抽检或排查确认系描述不当、质量不合格应召回的，卖家需主动并及时发起召回。卖家对商品批次提出异议的，应提供相关证据予以证明。</p>
				        
				        <div class="special-clause">
				          <p>描述不当、质量不合格应当召回的情形，包括但不限于：</p>
				          <p>（一）对消费者人身或财产造成安全隐患风险的；</p>
				          <p>（二）不符合国家强制性产品认证的（3C）；</p>
				          <p>（三）"三无"产品。</p>
				        </div>
				        
				        <p>6、同意并执行平台理念：服务、利他、共享、开放</p>
				        <p>同意并执行平台精神：爱、舍、给、聚 德、义、信、智</p>
				        <p>同意并执行平台目标：服务中国企业、服务全球绿色环保、美化环境造福人类。</p>
				        <p>同意并执行平台梦想：中国环保梦、中链企通梦</p>
				        <p>同意并执行平台政策：国家各项政策，平台各项制度</p>
				      </div>
				    </el-collapse-item>
				
				    <!-- 第五条 会员资格的取消 -->
				    <el-collapse-item title="第五条 会员资格的取消" name="5">
				      <div class="clause-content">
				        <p>如发现乙方有以下故意行为之一，甲方保留取消其使用服务的权利，并无需做出任何补偿；</p>
				        <p>1．可能造成本网站全部或局部的服务受影响，或危害本网站运行</p>
				        <p>2．以任何欺诈行为获得会员资格；</p>
				        <p>3．在本网站内从事非法商业行为，发布涉及敏感政治、宗教、色情或其它违反有关国家法律和政府法规的文字、图片等信息；</p>
				        <p>4．以任何非法目的而使用网络服务系统。</p>
				      </div>
				    </el-collapse-item>
				
				    <!-- 第七条 附则 -->
				    <el-collapse-item title="第七条 附则" name="7">
				      <div class="clause-content">
				        <p>1．本网会员因违反以上规定而触犯有关法律法规，一切后果自负，甲方不承担任何责任；</p>
				        <p>2．本协议未涉及之问题参见有关法律法规，当本规定与有关法律法规冲突时，以相应的法律法规为准。在本条款规定范围内，甲方拥有最终解释权。</p>
				        <p>3、以上各条款最终解释权归河北冠宇环保设备股份有限公司</p>
				      </div>
				    </el-collapse-item>
				
				    <!-- 第八条 争议解决 -->
				    <el-collapse-item title="第八条 争议解决" name="8">
				      <div class="clause-content">
				        <p>双方发生争议应当协商解决，解决无果向甲方所在地人民法院起诉。</p>
				      </div>
				    </el-collapse-item>
				  </el-collapse>
				</div>
		      </div>
		      <div slot="footer" class="dialog-footer">
		        <div class="scroll-indicator" :class="{reached: isScrolledToBottom}">
		          <i class="el-icon" :class="isScrolledToBottom ? 'el-icon-success' : 'el-icon-warning'"></i>
		          {{ isScrolledToBottom ? '已阅读全部内容' : '请滚动到底部阅读商家入驻协议、商品质量召回义务的全部内容' }}
		        </div>
		        <div>
		          <el-button @click="handleCancel">取消</el-button>
		          <el-button 
		            type="primary" 
		            :disabled="!isScrolledToBottom" 
		            @click="handleAgree">
		            同意并继续
		          </el-button>
		        </div>
		      </div>
		    </el-dialog>
	</el-form>
</template>

<script>
	export default {
		data() {
			return {
				Frperson:"",
				imgSrc:'this.src="' + require('../../assets/img/mr.jpg') + '"',
				loadingA:false,
				loadingB:false,
				peoname:"",
				imageUrlA:"",
				imageUrlB:"",
				checked:false,
				checked1: false,
				  checked2: false,
				  checked3: false,
				  dialogVisible: false,
				  isScrolledToBottom: false,
				  currentCheckbox: null,
				form: {
					cpcode:'',
					cperson: '',
					cphone: '',
					cphoto:'',
					cphoto_back:''
				},
				fileInfo:{
					type:"Member",
					zhengjian:"1"//身份证
				},
				imageUrl: '',
				rules: {
					cphoto: [{
						required: true,
						message:'请上传身份证人像面'
					}],
					cphoto_back: [{
						required: true,
						
						message:'请上传身份证国徽面'
					}],
					cpcode:[{
						required: true,
						message: '请输入注册人身份证号'
					}],
					cperson: [{
						required: true,
						message: '请输入注册人'
					}],
					cphone: [{
						required: true,
						message: '请输入联系电话'
					}],
					
				},
				picUrl:''
			}
		},
		mounted(){
			
		},
		created() {
			this.picUrl = this.$store.state.BASE_URL+'/uploadImgOne.html'
			if(this.$route.query.queryForm.cphoto || this.$route.query.queryForm.cphoto_back){
				this.form = this.$route.query.queryForm
				this.imageUrlA = this.$route.query.queryForm.cphoto ? this.$store.state.IMG_URL+'/'+this.$route.query.queryForm.cphoto :''
				this.imageUrlB = this.$route.query.queryForm.cphoto_back ? this.$store.state.IMG_URL+'/'+this.$route.query.queryForm.cphoto_back :''
			}
		},
		methods: {
			handleCheckboxChange(isChecked) {
			  if (isChecked) {
			    this.dialogVisible = true;
			    // 重置滚动状态
			    this.isScrolledToBottom = false;
			    // 滚动到顶部
			    this.$nextTick(() => {
			      if (this.$refs.dialogContent) {
			        this.$refs.dialogContent.scrollTop = 0;
			      }
			    });
			  }
			},
			handleAgree() {
			  this.$message({
			    message: '您已同意协议条款',
			    type: 'success'
			  });
			  this.dialogVisible = false;
			},
			handleCancel() {
			  // 取消时重置对应的复选框
			  if (this.currentCheckbox === 1) this.checked1 = false;
			  if (this.currentCheckbox === 2) this.checked2 = false;
			  if (this.currentCheckbox === 3) this.checked3 = false;
			  this.checked1 = false
			  
			  this.dialogVisible = false;
			  this.$message({
			    message: '您已取消协议确认',
			    type: 'info'
			  });
			},
			handleScroll() {
			  const content = this.$refs.dialogContent;
			  console.log("滚到拿了?",content)
			  if (content) {
			    // 检查是否滚动到底部
			    const scrollTop = content.scrollTop;
			    const scrollHeight = content.scrollHeight;
			    const clientHeight = content.clientHeight;
			    
			    // 当滚动到距离底部10px以内时，认为已经滚动到底部
			    this.isScrolledToBottom = (scrollTop + clientHeight) >= (scrollHeight - 10);
				console.log("当滚动到距离底部?",this.isScrolledToBottom)
			  }
			},
			 handleSubmit() {
			  if (this.allChecked) {
				this.$message({
				  message: '提交成功！',
				  type: 'success'
				});
			  }
			},
			changeA(event, file, fileList){
				this.loadingA = true;
			},
			handleCardA(res, file) {
				// this.handleAvatar(res, file,2)
				if (res.code == 200) {
				   this.loadingA = false;
				   this.form.cperson= res.data.data.姓名
				   this.form.cpcode=  res.data.data.公民身份号码
				   this.form.cphoto = res.data.src
				   this.imageUrlA = URL.createObjectURL(file.raw);
				   let peocode = res.data.data.公民身份号码
				   this.peoname = res.data.data.姓名
				   let peoadress = res.data.data.住址
				   if (!peocode || !this.peoname || !peoadress) {
						this.$message.error("图片不正确/不清晰,请重新上传~")
				   } else {
						this.$message.success("上传成功")
				   }
				}else{
					this.loadingA = false;
					this.$message.error(res.msg)
				}
				
			},
			beforeAvatarUploadA(file){
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			changeB(event, file, fileList){
				this.loadingB = true;
			},
			handleCardB(res, file) {
				// this.handleAvatar(res, file,3)
				if (res.code == 200) {
					this.loadingB = false;
				   this.form.cphoto_back = res.data.src
				   this.imageUrlB = URL.createObjectURL(file.raw);
				   this.$message.success("上传成功")
				  }else{
					  this.loadingB = false;
					  this.$message.error(res.msg)
				  }
			},
			beforeAvatarUploadB(file){
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			onSubmit(data) {
				if(this.checked1){
					this.$refs.form.validate((valid) => {
						if (valid) {
							this.$emit('eventSubmit', this.form)
						} else{
							this.$message.error("请仔细核对信息并上传与注册人姓名一致的身份证照片~")
							return false;
						}
					});
				}else{
					this.$message.error("请阅读并勾选")
					
				}
				
			}
		},
	}
</script>

<style>
	.el-dialog__body{
		line-height: 30px !important;
	}
	.page-title{
		text-align: center;
		font-size: 20px;
	}
	.card{
		display: flex;
		justify-content: space-around;
	}
	.red{
		color: red;
		margin-left: 150px;
		height: 50px;
		line-height: 30px;
	}
	.tishinews{
		color: #666ee8;
	}
	span.text_{
		color:#474747;
	}
	    .app-container {
	      max-width: 1000px;
	      margin: 0 auto;
	      padding: 30px;
	      background: white;
	      border-radius: 12px;
	      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
	    }
	    .header {
	      text-align: center;
	      margin-bottom: 40px;
	      padding-bottom: 20px;
	      border-bottom: 1px solid #eaeaea;
	    }
	    .header h1 {
	      color: #409EFF;
	      margin-bottom: 15px;
	      font-size: 32px;
	    }
	    .header p {
	      color: #606266;
	      font-size: 16px;
	      line-height: 1.6;
	    }
	    .main-content {
	      display: flex;
	      flex-direction: column;
	      align-items: center;
	      gap: 30px;
	    }
	    .checkbox-section {
	      background: #f9f9f9;
	      padding: 25px;
	      border-radius: 8px;
	      width: 100%;
	      max-width: 600px;
	      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
	    }
	    .checkbox-section h2 {
	      color: #409EFF;
	      margin-bottom: 15px;
	      font-size: 22px;
	    }
	    .checkbox-section p {
	      color: #606266;
	      margin-bottom: 20px;
	      line-height: 1.6;
	    }
	    .checkbox-group {
	      display: flex;
	      flex-direction: column;
	      gap: 15px;
	    }
	    .checkbox-item {
	      display: flex;
	      align-items: flex-start;
	      gap: 10px;
	      padding: 12px;
	      border-radius: 6px;
	      transition: background 0.3s;
	    }
	    .checkbox-item:hover {
	      background: #edf5ff;
	    }
	    .checkbox-item label {
	      cursor: pointer;
	      line-height: 1.5;
	    }
	    .demo-button {
	      margin-top: 20px;
	      text-align: center;
	    }
	    .dialog-content {
	      max-height: 400px;
	      overflow-y: auto;
	      padding: 15px;
	      border: 1px solid #eaeaea;
	      border-radius: 6px;
	      margin-bottom: 20px;
	    }
	    .dialog-footer {
	      display: flex;
	      justify-content: space-between;
	      align-items: center;
	      margin-top: 20px;
	    }
	    .scroll-indicator {
	      color: #909399;
	      font-size: 14px;
	      display: flex;
	      align-items: center;
	      gap: 5px;
	    }
	    .scroll-indicator.reached {
	      color: #67C23A;
	    }
	    .terms-section {
	      margin-bottom: 20px;
	    }
	    .terms-section h3 {
	      color: #409EFF;
	      margin-bottom: 15px;
	      font-size: 18px;
	    }
	    .terms-content {
	      line-height: 1.7;
	      color: #606266;
	    }
	    .terms-content p {
	      margin-bottom: 15px;
	    }
	    .terms-content ul {
	      padding-left: 20px;
	      margin-bottom: 15px;
	    }
	    .terms-content li {
	      margin-bottom: 8px;
	    }
	    .footer {
	      text-align: center;
	      color: #909399;
	      font-size: 14px;
	      margin-top: 40px;
	      padding-top: 20px;
	      border-top: 1px solid #eaeaea;
	    }
	    .el-checkbox__input.is-checked .el-checkbox__inner {
	      background-color: #409EFF;
	      border-color: #409EFF;
	    }
	    .el-checkbox__input.is-checked + .el-checkbox__label {
	      color: #409EFF;
	    }
	    .el-button--primary {
	      background-color: #409EFF;
	      border-color: #409EFF;
	    }
	    .el-button--primary:focus, .el-button--primary:hover {
	      background-color: #66b1ff;
	      border-color: #66b1ff;
	    }
</style>
